import { Box } from "@mui/material";
import { useState } from "react";
import { SEO } from "../../components/seo";
import Text from "../../components/ui/Text";
import { PAGE_SEO } from "../../constants/seo";
import { GameHistory, YourGroups, YourUpcomingGames } from "./parts";

const Dashboard = () => {
  const [gameHistoryCount] = useState(2);

  return (
    <Box>
      <SEO
        title={PAGE_SEO.DASHBOARD.title}
        description={PAGE_SEO.DASHBOARD.description}
        keywords={PAGE_SEO.DASHBOARD.keywords}
      />
      <Text variant="pageHeader" sx={{ mb: 3 }}>
        Dashboard
      </Text>

      <Box
        sx={{
          display: "flex",
          gap: 3,
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        {/* Your upcoming games - flex grows */}
        <YourUpcomingGames />

        {/* Right Column - flex column */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            width: { xs: "100%", md: 320 },
            flex: 1,
          }}
        >
          {/* Your groups */}
          <YourGroups />

          {/* Game history */}
          <GameHistory gameHistoryCount={gameHistoryCount} />
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
